import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const WelcomeBanner = () => {
  return (
    <div className="w-full bg-gradient-to-br from-primary to-secondary rounded-xl md:rounded-2xl lg:rounded-3xl overflow-hidden shadow-organic-lg">
      <div className="relative h-48 md:h-56 lg:h-64">
        <Image
          src="https://images.unsplash.com/photo-1692594469401-1579f4b50562"
          alt="Stand up paddle boarder gliding across calm turquoise water at sunset with mountains in background"
          className="w-full h-full object-cover opacity-30" />

        <div className="absolute inset-0 bg-gradient-to-t from-primary/90 to-transparent" />
        
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 md:px-6 lg:px-8">
          <div className="flex items-center gap-3 md:gap-4 mb-4 md:mb-5 lg:mb-6">
            <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 bg-white rounded-xl md:rounded-2xl flex items-center justify-center shadow-organic">
              <Icon name="Waves" size={28} color="var(--color-primary)" strokeWidth={2.5} />
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white">
              PaddleTurkiye
            </h1>
          </div>
          
          <p className="text-base md:text-lg lg:text-xl text-white/90 font-medium max-w-md">
            Türkiye'nin SUP Topluluğuna Hoş Geldiniz
          </p>
          
          <div className="flex items-center gap-2 md:gap-3 mt-4 md:mt-5 lg:mt-6 text-white/80">
            <Icon name="MapPin" size={18} />
            <span className="text-sm md:text-base">Türkiye Geneli</span>
          </div>
        </div>
      </div>

      <div className="bg-white/10 backdrop-blur-sm px-4 md:px-6 lg:px-8 py-3 md:py-4">
        <div className="flex items-center justify-center gap-6 md:gap-8 lg:gap-10 text-white">
          <div className="flex items-center gap-2">
            <Icon name="Shield" size={16} />
            <span className="text-xs md:text-sm font-medium">Güvenli</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Users" size={16} />
            <span className="text-xs md:text-sm font-medium">12,500+ Üye</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Star" size={16} />
            <span className="text-xs md:text-sm font-medium">4.8 Puan</span>
          </div>
        </div>
      </div>
    </div>);

};

export default WelcomeBanner;